package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun WallOfFireMetadata() {
    SpellMetadata(
        spellIndex = "wall-of-fire",
        castingTime = "1 action",
        range = "120 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A small piece of phosphorus.",
        duration = "Up to 1 minute",
        damageBase = "Fire 5d8",
        damageScaling = null,
        savingThrow = "DEX (Half)",
        aoe = "60-ft Line",
        concentration = true
    )
}
